import React, {Component} from 'react';
import { connect } from 'react-redux';
import { ChartContainer, ChartRow, Charts, Legend, LineChart, Resizable, styler, YAxis } from "react-timeseries-charts";
import moment from "moment/moment";
import getLocations from '../selectors/locations';
import {getMonthDates,getYesterdayDate} from '../util/util';
import { TimeSeries } from 'pondjs';

const columnNames = ['performance','groupedPerformance','cp'];

const style = styler([
    { key: "performance", color: "#0d7fa0", width: 2 },
    { key: "groupedPerformance", color: "#ff5e0e", width: 2 },
    { key: "cp", color: "#5f5f5f", width: 2 }
]);

class ItemMonthStat extends Component{

    constructor(props) {
        super(props);
        this.state = {
            active: {
                cp: true,
                performance: !props.filters.showGrouped,
                groupedPerformance: props.filters.showGrouped
            }
        };
    }

    handleActiveChange = key => {
        const active = this.state.active;
        active[key] = !active[key];

        this.setState({ active });
    }

    getCharts = (series) => {

        const {active} = this.state;

        let charts = [];
        columnNames.forEach((column,ndx) =>{
            if(active[column]) {
                charts.push(
                    <LineChart key={ndx} style={style} axis={column === 'cp' ? 'cp' : 'performance'} series={series}
                               columns={[column]} interpolation="curveBasis"/>
                    //column === 'cp' ? 'curveBasis' : 'curveLinear'
                );
            }
        });
        return charts;
    }

    getChartTitle = () => {
        const {monthItems, itemId} = this.props;

        const {active} = this.state;

        let location = '';

        let chartTitle = '';

        if(active['groupedPerformance']){
            let itemsYest = monthItems[getYesterdayDate()];
            if(itemsYest) {
                location = itemsYest.find(item => item.id === itemId).location;
                chartTitle = location;
            }
        }
        return chartTitle;
    }

    render() {
        const {monthItems, itemId, filters} = this.props;

        const {active} = this.state;

        const monthDates = getMonthDates();

        let points = [];

        monthDates.forEach(date => {
            let timestamp = moment(date);
            let items = filters.showInverters ? monthItems[date] : getLocations(monthItems[date]);
            if(items){
                let item = items.find(item => item.id === itemId);
                if(item){
                    let performance = parseInt(item.performance,10);
                    let groupedPerformance = parseInt(item.groupedPerformance,10);
                    let cp = parseInt(item.cp,10);
                    points.push([timestamp,performance,groupedPerformance,cp]);
                }
                else{
                    console.log(`geen item`);
                }
            }
        });

        let series = new TimeSeries({
           name: 'itemstats',
           columns: ['time',...columnNames],
           points: points
        });

        const legendCategories = [
            {
                key: "cp",
                label: "Cp",
                disabled: !active.cp
            },
            {
                key: "performance",
                label: "Performance",
                disabled: !active.performance
            },
            {
                key: "groupedPerformance",
                label: "Grouped Performance",
                disabled: !active.groupedPerformance
            }
        ];

        const minPerformance = series.min('performance') < series.min('groupedPerformance') ? series.min('performance') : series.min('groupedPerformance');
        const maxPerformance = series.max('performance') > series.max('groupedPerformance') ? series.max('performance') : series.max('groupedPerformance');

        return (
            <div>
                <div>
                    <Legend
                        categories={legendCategories}
                        style={style}
                        type="swatch"
                        onSelectionChange={this.handleActiveChange}
                    />
                </div>
            <div>
                <Resizable>
                    <ChartContainer
                        timeRange={series.range()}
                        title={this.getChartTitle()}
                        style={{
                            background: "#ffffff",
                            borderRadius: 8,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderColor: "#ffad13"
                        }}
                        maxTime={series.range().end()}
                        minTime={series.range().begin()}
                    >
                        <ChartRow height="350">
                            <YAxis
                                id="performance"
                                label="Performance (%)"
                                min={minPerformance}
                                max={maxPerformance}
                                width="60"
                                style={{labelColor:"#fff"}}
                                type="linear"
                            />
                            <Charts>
                                {
                                    this.getCharts(series)
                                }
                           </Charts>
                            <YAxis
                                id="cp"
                                label="CP"
                                min={series.min('cp')}
                                max={series.max('cp')}
                                width="60"
                                type="linear"
                            />
                        </ChartRow>
                    </ChartContainer>
                </Resizable>
            </div>
            </div>
        )
    }
}

let mapStateToProps = state => ({
    monthItems: state.monthItems,
    filters: state.filters,
});

export default connect(mapStateToProps)(ItemMonthStat);



// WEBPACK FOOTER //
// ./src/components/ItemMonthStat.js